module.exports = __webpack_public_path__ + "img/calendar-icon-orange.f094cf01.svg";